/* eslint-disable no-console */

import axios from 'axios';
import router from '../router';
import store from '../store/store';
import config from './config/config';

const HTTP = axios.create();
let allowRefresh = true;
// Add a request interceptor
HTTP.interceptors.request.use((request) => {
  request.headers = {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + store.getters['user/accessToken'],
  };
  if (request.url.indexOf('http') === -1) {
    // Do something before request is sent
    request.url = config.BASE_URL + request.url;
  }
  return request;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
HTTP.interceptors.response.use((response) => {
  return response;
}, (error) => {
  // are we allowed to refresh AND is this a 401?
  if (allowRefresh && error !== undefined &&
    error.response !== undefined
    && (error.response.status === 401 || error.response.status === 403)) {
    // we can only allow them to refresh once,
    // so turn this toggle off so they will be redirected if
    // the refresh response is also a 401
    allowRefresh = false;
    return store.dispatch('user/refresh').then(() => {
      return HTTP(error.config).then(data => {
        allowRefresh = true;
        return data;
      }).catch((err) => {
        console.log('refresh token failed ?' + err);
        throw (err);
      });
    }).catch((err) => {
      store.dispatch('user/logOut').then(() => {
        console.log(window.location.href);
        router.go('/login?returnUrl=' + window.location.href);
        throw (err);
      });
    });
  }
  throw error;
});

export default HTTP;



// WEBPACK FOOTER //
// ./src/api/HTTP.js